import { Divider, Shape, ShapeProps } from '@teko/ds-desktop';
import { FreeShippingColored } from '@teko/ds-icon';
import {
  Information,
  PolicyAndService,
  SellerCard,
} from '@teko/teko-ecommerce';
import { DividerStyleEnum } from '@teko/types/dist/shared';
import { FreeShipping, ShippingInfo } from 'components/ProductDetail/styles';
import { useProductDetailState } from 'contexts';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';
import React from 'react';

interface PoliciesProps {
  wrapperProps?: ShapeProps;
  showFreeShip?: boolean;
}
export const Policies: React.FC<PoliciesProps> = ({
  wrapperProps,
  showFreeShip = true,
}: PoliciesProps) => {
  const { product, price, salePolicies, otherPolicies } =
    useProductDetailState();
  const provider = product?.provider;

  const { freeShippingThreshold } = useTenantConfig();

  const shouldShowFreeShip =
    showFreeShip &&
    typeof freeShippingThreshold === 'number' &&
    freeShippingThreshold >= 0 &&
    (price?.finalPrice || 0) >= freeShippingThreshold;

  const renderProviderInfo = () => {
    if (!!provider) {
      return (
        <SellerCard
          padding="s16"
          name={provider.name}
          slogan={provider.slogan}
          avatar={{ src: provider.logo || '' }}
          link={{
            href: `/cua-hang/${provider.id}?pageTitle=${provider.name}`,
          }}
        />
      );
    }
    return null;
  };

  const renderFreeshipInfo = () => {
    if (shouldShowFreeShip) {
      return (
        <>
          <FreeShipping>
            <FreeShippingColored size={24} color="#53c305" />
            <ShippingInfo>{t('Sản phẩm được miễn phí giao hàng')}</ShippingInfo>
          </FreeShipping>
          <Divider
            dividerStyle={DividerStyleEnum.dashed}
            color="#e0e0e0"
            gap="16px"
          />
        </>
      );
    }
    return null;
  };

  if (!product) {
    return null;
  }

  // render both sale policies and other policies

  if (
    !provider &&
    !shouldShowFreeShip &&
    !salePolicies?.length &&
    !otherPolicies?.length
  ) {
    return null;
  }
  return (
    <Shape {...wrapperProps}>
      {renderProviderInfo()}
      {shouldShowFreeShip || salePolicies?.length || otherPolicies?.length ? (
        <Shape
          backgroundColor="white"
          borderRadius="m"
          className="BOXCARDBODY-RIGHT"
          padding="s16"
        >
          {renderFreeshipInfo()}
          {salePolicies?.length ? (
            <PolicyAndService
              title={t('Chính sách bán hàng')}
              information={salePolicies as Information[]}
              className="att-product-detail-sale-policies"
            />
          ) : null}
          {otherPolicies?.length ? (
            <PolicyAndService
              title={t('Dịch vụ khác')}
              information={otherPolicies as Information[]}
              marginTop="s24"
              className="att-product-detail-other-services"
            />
          ) : null}
        </Shape>
      ) : null}
    </Shape>
  );
};
